import type { SpacingSize } from '@/lib/contentful/types';

export const SPACING_MAP: Record<SpacingSize, string> = {
  none: '0',
  small: 'var(--space-4)',
  medium: 'var(--space-8)',
  large: 'var(--space-16)',
};

export const ASPECT_RATIO_MAP: Record<string, string> = {
  portrait: '61 / 100',
  square: '1 / 1',
  landscape: '16 / 9',
  auto: 'auto',
};
